<template>
  <b-card header-tag="header">
    <h3 slot="header">Jury</h3>
    <div v-if="!isLoadingList" class="card-text">
      <p>We need your help to jury the SV applications.
        <br>All applications must be juried by <strong>{{ juryDeadlineFormat }}.</strong>
      </p>
      <p>You've been assigned {{ assignments.length }} applications to score.</p>
      <p>You've scored {{ assignmentsScored.length }} applications.</p>
      <router-link :to="{ name: 'ListJuryApplications'}">
        <button type="button" class="btn arrow-btn-primary btn-lg arrow-btn-black">View Applications</button>
      </router-link>
    </div>
    <span v-else>Loading</span>
  </b-card>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import moment from 'moment'

  export default {
    name: 'Jury',
    data () {
      return {
        isLoadingList: false
      }
    },
    computed: {
      ...mapState(['juryDeadline']),
      ...mapState('jury', ['assignments']),
      ...mapGetters('jury', ['listAssignments']),
      juryDeadlineFormat: function () {
        return moment(this.juryDeadline).format('MMMM Do')
      },
      assignmentsScored: function () {
        return this.listAssignments.filter(a => a.isScored)
      }
    },
    created: function () {
      if (this.$store.state.jury.assignments.length === 0) {
        this.isLoadingList = true
        this.$store.dispatch('jury/getTLAssignments').then(() => {
          this.isLoadingList = false
        }).catch(err => {
          console.log(err)
          this.isLoadingList = false
        })
      }
    }
  }
</script>

<style scoped>
  .col {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Jury.vue